import { FlexGrowCol, FlexGrowRow, FlexRow } from '@xylabs/sdk-react'
import React from 'react'

import { GeotokenIdentification } from '../../../Components'
import { useGeotoken } from '../../../Contexts'
import { GeotokenSettingsDetails } from '../../Geotoken'

const Viewer: React.FC = () => {
  const geotoken = useGeotoken()

  return (
    <FlexGrowRow marginY={1}>
      <FlexGrowCol paper>
        <FlexRow padding={1} justifyContent="flex-start">
          <GeotokenIdentification quadkey={geotoken?.quadkey} />
        </FlexRow>
        <GeotokenSettingsDetails />
      </FlexGrowCol>
    </FlexGrowRow>
  )
}

export default Viewer
